// extracted by mini-css-extract-plugin
export default {"customInputBasic":"ConsultorioSelector_customInputBasic__vO0j3"};